import { AxiosResponse } from 'axios';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getReports } from 'services/claimsService';
import { ApplicationState } from 'store/store.inteface';
import { ApiResponse } from 'types/ApiResponse';
import { SagasAction } from 'types/SagasAction';

import { setReportsAction, setError } from './actions';
import { REPORTS_TYPES, Reports, GetReports } from './types';

export function* setReportsSaga({ payload }: SagasAction<GetReports>) {
  yield put(setError(null));
  try {
    const { cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );

    const { data }: AxiosResponse<ApiResponse<Reports>> = yield call(
      getReports,
      cpId,
      payload,
    );
    yield put(setReportsAction(data));
  } catch (error) {
    if (error.response && error.response.status === 404) {
      yield put(setError(error.response.data.reason));
    } else {
      console.log(error);
    }
  }
}

export default all([
  takeLatest(REPORTS_TYPES.GET_REPORTS_REQUEST, setReportsSaga),
]);
